/*
 * Yoni start bar: the sticky "Start my ritual" pill the buy box section puts at the bottom of a phone screen
 * ([data-start-bar], CSS in sections/yoni-buy-box.liquid; hidden for good from 750px by CSS).
 *
 *   hidden at the top; shows once the hero's main button has scrolled out of view (a page with no hero button:
 *   after the first 70% of a screen); hides again while the buy box is on screen and from the closing banner
 *   (.yoni-cta-section, which has its own button) or the footer down.
 *   Tapping it scrolls to the buy box: instant when motion is off or reduced, a glide otherwise.
 *
 * One scroll listener (any scroller, in capture, one frame at a time) measures three boxes and toggles
 * .is-on; the motion itself is a CSS transition (opacity + transform), so a change mid-way turns around from
 * where it is. While it is hidden it is inert and out of the reading order (inert, aria-hidden, tabindex -1).
 * Re-initialises on shopify:section:load so the theme editor stays usable.
 */
(function () {
  var bars = [];
  var raf = 0;

  function calm() {
    return window.yoniCalm ? window.yoniCalm() : !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function show(bar, on) {
    if (bar._on === on) return;
    bar._on = on;
    bar.classList.toggle('is-on', on);
    bar.inert = !on;
    if (on) bar.removeAttribute('aria-hidden'); else bar.setAttribute('aria-hidden', 'true');
    bar._link.tabIndex = on ? 0 : -1;
  }

  function measure() {
    raf = 0;
    var vh = window.innerHeight;
    var foot = document.querySelector('.yoni-cta-section, footer'); // the first in the page: the banner, if any
    var inFoot = !!foot && foot.getBoundingClientRect().top < vh;
    bars = bars.filter(function (bar) { return document.contains(bar); });
    bars.forEach(function (bar) {
      var hero = document.querySelector('.yoni-hero__ctas .yoni-btn--primary');
      var past = hero ? hero.getBoundingClientRect().bottom < 0 : (document.scrollingElement || document.documentElement).scrollTop > vh * 0.7;
      var r = bar._box.getBoundingClientRect();
      var inBox = r.top < vh && r.bottom > 0;
      show(bar, past && !inBox && !inFoot);
    });
  }
  function queue() { if (!raf) raf = requestAnimationFrame(measure); }

  function init(bar) {
    if (bar.dataset.yoniStartInit === '1') return;
    var link = bar.querySelector('[data-start-link]');
    var box = link && link.hash.length > 1 ? document.getElementById(link.hash.slice(1)) : null;
    if (!link || !box) return;
    bar.dataset.yoniStartInit = '1';
    bar._link = link;
    bar._box = box;
    bar._on = null;
    bars.push(bar);

    link.addEventListener('click', function (e) {
      e.preventDefault();
      box.scrollIntoView({ behavior: calm() ? 'instant' : 'smooth', block: 'start' }); // section[id] keeps its scroll-margin under the header
      box.setAttribute('tabindex', '-1');
      box.focus({ preventScroll: true });
    });
    queue();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-start-bar]').forEach(init);
  }

  document.addEventListener('scroll', queue, { passive: true, capture: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  if (document.readyState !== 'loading') initAll(document);
  else document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
